// Флаг «доступ заблокирован из-за 2FA». Основной триггер блок-экрана — is2faEnabled из SSR (App.tsx);
// этот стор — fallback на runtime: если require2fa включат / 2FA отзовут при открытой вкладке,
// axios-интерсептор (app.tsx) на 403 TWO_FA_REQUIRED поднимет флаг без перезагрузки.

let blocked = false;
const listeners = new Set<() => void>();

export const isTwoFaBlocked = (): boolean => blocked;

export const triggerTwoFaBlock = (): void => {
    if (blocked) {
        return;
    }
    blocked = true;
    listeners.forEach((listener) => listener());
};

export const subscribeTwoFaBlock = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
